export const mobileOnly = 'min-width: 360px';
export const phablet = 'min-width: 576px';
export const tablet = 'min-width: 768px';
export const laptop = 'min-width: 992px';
export const desktop = 'min-width: 1200px';
export const largeDesktop = 'min-width: 1440px';
export const xLargeDesktop = 'min-width: 1600px';

const mediaBreakpoints = {
    mobileOnly,
    phablet,
    tablet,
    laptop,
    desktop,
    largeDesktop,
    xLargeDesktop,
};

export default mediaBreakpoints;
